import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TabPanel as HeadlessTabPanel, TransitionRoot } from "@headlessui/vue";
// eslint-disable-next-line
interface PanelProps extends ExtractProps<typeof HeadlessTabPanel> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'Panel',
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HeadlessTabPanel), { as: "template" }, {
    default: _withCtx(({ selected }) => [
      _createVNode(_unref(TransitionRoot), {
        appear: "",
        as: "div",
        show: selected,
        enter: "transition-opacity duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-300",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", { selected: selected })
        ]),
        _: 2
      }, 1032, ["show"])
    ]),
    _: 3
  }))
}
}

})